module.exports = __webpack_public_path__ + "img/flowers.efe92be3.png";